module.exports = __webpack_public_path__ + "static/media/igraphic.5ec20296.png";